export function hostReportError(err) {
    setTimeout(() => { throw err; }, 0);
}
